import React from 'react'

import queryString from 'query-string'

import { Portlet, Button, Col, Row, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import EstadosTransferenciasConstant from 'constants/estadosTransferencias'
import TiposDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'
import { TiposTransferenciaConstant } from 'constants/index'

import * as TransferenciasService from 'services/transferencia.service'
import * as GuiaVentaService from 'services/guiasVenta.service'

import FechaEmisionFormGroup from './formGroups/fechaEmision'
import IdSedeDestinoFormGroup from './formGroups/idSedeDestino'
import EstadoFormGroup from './formGroups/estado'

import { DateHandler, DownloadAxiosFile } from 'utils'

const portletBreadcrumbs = [{ name: 'Transferencias por Salida' }]

const TransferenciasPorSalidaPage = ({ location, history }) => {
  const tablaRef = React.useRef(null)

  const initialQueryParams = React.useMemo(() => {
    if (location.search) {
      const parsed = queryString.parse(location.search)
      return parsed
    } else {
      return {}
    }
  }, [location.search])

  const fechaDefault = React.useMemo(() => {
    const nuevaFecha = DateHandler.format(new Date())
    return nuevaFecha
  }, [])

  const [fechaEmision, setFechaEmision] = React.useState(initialQueryParams.fe || fechaDefault)
  const [idSedeDestino, setIdSedeDestino] = React.useState(initialQueryParams.idsd || '')
  const [estado, setEstado] = React.useState(initialQueryParams.e || EstadosTransferenciasConstant.ENVIO_ENVIADO)

  const clickBuscarHandler = () => {
    const queryParams = queryString.stringify({
      idsd: idSedeDestino,
      fe: fechaEmision,
      e: estado
    })
    history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA}?${queryParams}`)
    tablaRef.current.reload({
      idSedeDestino: idSedeDestino,
      fechaEmision: fechaEmision,
      estado: estado
    })
  }

  const clickNuevoHandler = e => {
    e.preventDefault()
    const queryParams = queryString.stringify({
      idsd: idSedeDestino,
      fe: fechaEmision,
      e: estado
    })

    history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_NUEVO}?${queryParams}`)
  }

  const clickVerDetalles = ({ _id }) => {
    const queryParams = queryString.stringify({
      idsd: idSedeDestino,
      fe: fechaEmision,
      e: estado
    })

    history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_DETALLE}/${_id}?${queryParams}`)
  }

  const clickImprimir = React.useCallback(async ({ _id, tipoDocumento }) => {
    if (tipoDocumento === TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE) {
      GuiaVentaService.descargarPdfGuia(_id).then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
    } else {
      await TransferenciasService.imprimirTransferencia(_id).then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
    }
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Transferencias por Salida'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nueva Salida', onClick: clickNuevoHandler }]}
        />
        <Portlet.Body>
          <Row className='p-3'>
            <Col md={3}>
              <FechaEmisionFormGroup value={fechaEmision} onChange={e => setFechaEmision(e.target.value)} />
            </Col>
            <Col md={3}>
              <IdSedeDestinoFormGroup value={idSedeDestino} onChange={e => setIdSedeDestino(e.target.value)} />
            </Col>
            <Col md={3}>
              <EstadoFormGroup value={estado} onChange={e => setEstado(e.target.value)} />
            </Col>
            <Col md={3}>
              <Button onClick={clickBuscarHandler}>Buscar</Button>
            </Col>
          </Row>
          <Table.ServerSide
            hideOnEmpty
            ref={tablaRef}
            useNest={true}
            url='/transferencias'
            baseParams={{
              tipoConsulta: TiposTransferenciaConstant.SALIDA,
              estado: estado
            }}
            headRows={[
              { id: 'fecEmision', label: 'FEC. EMISION' },
              { id: 'tipoDocumento', label: 'TIPO DOCUMENTO' },
              { id: 'documento', label: 'DOCUMENTO' },
              { id: 'sedeDestino', label: 'ESTABLECIMIENTO DESTINO' },
              { id: 'nombre', label: 'USUARIO' },
              { id: 'uMedida', label: 'ESTADO' },
              { id: 'options', label: '' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>
                  {row.tipoDocumento ? TiposDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell>
                  {row.serieDocumento || '--'} - {row.numeroDocumento || '--'}
                </Table.Cell>
                <Table.Cell>{row.sedeDestino || '--'}</Table.Cell>
                <Table.Cell>{row.usuario || '--'}</Table.Cell>
                <Table.Cell>
                  {row.estadoEnvio ? EstadosTransferenciasConstant.__dictionary[row.estadoEnvio].nombre : '--'}
                </Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='imprimirPdf'
                        handleClose={handleClose}
                        onClick={e =>
                          clickVerDetalles({
                            _id: row._id
                          })
                        }
                      >
                        Ver Detalles
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='imprimirExcel'
                        handleClose={handleClose}
                        onClick={e => clickImprimir(row)}
                      >
                        Imprimir
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default TransferenciasPorSalidaPage
